import { NavigationStructure } from '@/components/navigation/common-navigation'
import { RouteName } from '@/configuration/route/route-names'

export const GeneratorsNavigationConfiguration: NavigationStructure = [
    {
        titleKey: 'navigation.tabs.portfolioOverview',
        destinationRouteName: 'Generators_PortfolioOverview',
        matchRouteNames: ['Generators_PortfolioOverview'],
    },
    {
        titleKey: 'navigation.tabs.componentStatus',
        destinationRouteName: 'Generators_ConditionStatus',
        matchRouteNames: ['Generators_ConditionStatus', RouteName.GeneratorsReportsViewCondition],
    },
    {
        titleKey: 'navigation.tabs.portfolioTrends',
        destinationRouteName: 'Generators_PortfolioTrends',
        matchRouteNames: ['Generators_PortfolioTrends'],
    },
]
